(function () {
  'use strict';

  const CONTACT_CAPTURE_MODES = new Set(['required', 'optional', 'skip']);

  function getUiLocale(preferredLocale) {
    const locale = (preferredLocale || document.documentElement.lang || '').toString().trim();
    return locale || 'en';
  }

  function normalizeWorkerLocale(value) {
    const normalized = (value || '').toString().trim().toLowerCase();
    if (normalized.startsWith('ar')) return 'ar';
    if (normalized.startsWith('es')) return 'es';
    return 'en';
  }

  function normalizeStoreConfig(rawStore) {
    const source = rawStore && typeof rawStore === 'object' ? rawStore : {};
    let allowEmailContact = source.allowEmailContact !== false;
    let allowMobileContact = !!source.allowMobileContact;
    if (!allowEmailContact && !allowMobileContact) allowEmailContact = true;

    const contactCaptureMode = CONTACT_CAPTURE_MODES.has(String(source.contactCaptureMode || '').trim())
      ? String(source.contactCaptureMode).trim()
      : 'required';

    let whatsappUrl = typeof source.whatsappUrl === 'string' ? source.whatsappUrl.trim() : '';
    const whatsappNumberE164 = typeof source.whatsappNumberE164 === 'string' ? source.whatsappNumberE164.trim() : '';
    if (!whatsappUrl && whatsappNumberE164) {
      whatsappUrl = `https://wa.me/${whatsappNumberE164.replace(/[^\d+]/g, '').replace(/^\+/, '')}`;
    }

    return {
      key: typeof source.key === 'string' ? source.key.trim().toLowerCase() : '',
      market: typeof source.market === 'string' ? source.market.trim().toLowerCase() : '',
      brandName: typeof source.brandName === 'string' ? source.brandName.trim() : '',
      contactCaptureMode,
      allowEmailContact,
      allowMobileContact,
      whatsappNumberE164,
      whatsappUrl,
    };
  }

  function buildStorePayload(rawStore) {
    const store = normalizeStoreConfig(rawStore);
    return {
      key: store.key || null,
      market: store.market || null,
      brandName: store.brandName || null,
      contactCaptureMode: store.contactCaptureMode,
      allowEmailContact: !!store.allowEmailContact,
      allowMobileContact: !!store.allowMobileContact,
      whatsappNumberE164: store.whatsappNumberE164 || null,
      whatsappUrl: store.whatsappUrl || null,
    };
  }

  function buildWorkerContextPayload(options) {
    const locale = normalizeWorkerLocale(options && options.locale);
    const storePayload = buildStorePayload(options && options.store);
    return {
      ui_locale: locale,
      response_language: locale,
      locale,
      language: locale,
      market: storePayload.market || null,
      store: storePayload,
    };
  }

  function isValidEmail(value) {
    if (!value) return false;
    const probe = document.createElement('input');
    probe.type = 'email';
    probe.value = value;
    return probe.checkValidity();
  }

  function normalizePhone(value) {
    const raw = (value || '').trim();
    if (!raw) return null;

    const normalizedDigits = raw
      .replace(/[٠-٩]/g, (digit) => String('٠١٢٣٤٥٦٧٨٩'.indexOf(digit)))
      .replace(/[۰-۹]/g, (digit) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(digit)));

    let normalized = normalizedDigits
      .replace(/[^\d+]+/g, '')
      .replace(/(?!^)\+/g, '');

    if (normalized.startsWith('00')) {
      normalized = `+${normalized.slice(2)}`;
    }

    const digits = normalized.replace(/\D/g, '');
    if (digits.length < 8 || digits.length > 15) return null;

    return normalized.startsWith('+') ? `+${digits}` : digits;
  }

  function parseContactValue(rawValue, options) {
    const config = options && options.store ? normalizeStoreConfig(options.store) : normalizeStoreConfig();
    const allowEmpty = !!(options && options.allowEmpty);
    const value = (rawValue || '').trim();

    if (!value) {
      return { valid: allowEmpty, empty: true, type: 'email', value: '' };
    }

    if (value.includes('@')) {
      if (!config.allowEmailContact) {
        return { valid: false, type: 'email', value };
      }

      return {
        valid: isValidEmail(value),
        type: 'email',
        value,
      };
    }

    if (!config.allowMobileContact) {
      return {
        valid: false,
        type: 'mobile',
        value,
        normalizedValue: null,
      };
    }

    const normalizedValue = normalizePhone(value);
    return {
      valid: !!normalizedValue,
      type: 'mobile',
      value,
      normalizedValue,
    };
  }

  function normalizeContactSnapshot(rawContact) {
    if (!rawContact || typeof rawContact !== 'object') return null;

    const rawType = (rawContact.type || '').toString().trim().toLowerCase();
    const type = rawType === 'phone' ? 'mobile' : rawType;
    if (type !== 'email' && type !== 'mobile') return null;

    return {
      type,
      value: typeof rawContact.value === 'string' ? rawContact.value.trim() : '',
      normalized_value: typeof rawContact.normalized_value === 'string' ? rawContact.normalized_value.trim() : null,
    };
  }

  window.TaraConsultationStore = Object.freeze({
    getUiLocale,
    normalizeWorkerLocale,
    normalizeStoreConfig,
    buildStorePayload,
    buildWorkerContextPayload,
    isValidEmail,
    normalizePhone,
    parseContactValue,
    normalizeContactSnapshot,
  });
})();
